// @flow
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import { useTranslation } from 'react-i18next';

import PlainNav, { NavItem } from 'app/common/ui/PlainNav';
import StudentsSelector from 'app/components/StudentsSelector';
import config from 'app/config';
import Loading from 'app/common/components/Loader';
import { subResetNotEnough } from 'app/actions/apps/subs/pay';
import { fetchApps } from 'app/actions/apps/apps';

import AssignedList from './AssignedList';
import NotAssignedList from './NotAssignedList';


const enhance = compose(
  connect(
    state => ({
      loading: state.apps.opts.loading,
    })
  ),

  lifecycle({
    componentWillUnmount() {
      const { dispatch } = this.props;
      dispatch(subResetNotEnough());
      dispatch(fetchApps());
    },
  })
);

type Props = {
  params: {
    id: string,
    type: string,
  },
  loading: boolean,
};

const Subs = ({ params: { id, type }, loading }: Props) => {
  const { t } = useTranslation('subs');

  return (
    <div>
      <PlainNav>
        <NavItem to={`/apps/${id}/assigned`}>
          {t('connected')}
        </NavItem>

        <NavItem to={`/apps/${id}/not-assigned`}>
          {t('not_connected')}
        </NavItem>
      </PlainNav>

      <StudentsSelector style={{ width: config.containerWidth }} />

      {loading && <Loading />}

      {type === 'assigned' && !loading && <AssignedList id={id} />}
      {type === 'not-assigned' && !loading && <NotAssignedList id={id} />}

    </div>
  );
};

export default withRouter(enhance(Subs));
